// extracted by mini-css-extract-plugin
export default {"col":"Month_col__z0fas"};